// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ue","contentWrapCtaDefault":"ve","disabled":"we","contentWrapCtaWhite":"xe","promos":"ye","lazyPromo":"ze","mainContent":"Ae","headingText":"Be","copy":"Ce","subtext":"De"};